import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material';

import { SSO_EXCEL_COLUMNS, SSO_GROUP_COLORS, SSO_HEADER_COLOR, SSO_MISSING_ID_COLOR } from './constants';
import { stripEmbeddedTitle } from './utils';

const formatCurrency = (amount) =>
  new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount || 0);

// หน้าตาตรงกับไฟล์ .xlsx จริงที่ backend สร้าง (สี/คอลัมน์/รูปแบบตัวเลขเดียวกัน) — ใช้ดูตัวอย่างก่อนดาวน์โหลด
export default function SsoPreviewTable({ rows }) {
  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow>
            {SSO_EXCEL_COLUMNS.map((c) => (
              <TableCell key={c.key} sx={{ bgcolor: SSO_HEADER_COLOR, fontWeight: 700, whiteSpace: 'nowrap' }}>
                {c.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.length === 0 && (
            <TableRow>
              <TableCell colSpan={SSO_EXCEL_COLUMNS.length} align="center">
                <Typography variant="body2" color="text.secondary" sx={{ py: 3 }}>ไม่มีรายชื่อที่เลือกไว้</Typography>
              </TableCell>
            </TableRow>
          )}
          {rows.map((row) => (
            <TableRow key={row.id} sx={{ bgcolor: SSO_GROUP_COLORS[row.group] || SSO_GROUP_COLORS.FULLTIME }}>
              <TableCell sx={{ color: !row.has_id_card ? SSO_MISSING_ID_COLOR : undefined }}>{row.tax_id || ''}</TableCell>
              <TableCell sx={{ color: !row.has_id_card ? SSO_MISSING_ID_COLOR : undefined }}>{row.title}</TableCell>
              <TableCell sx={{ color: !row.has_id_card ? SSO_MISSING_ID_COLOR : undefined }}>{stripEmbeddedTitle(row.firstname)}</TableCell>
              <TableCell sx={{ color: !row.has_id_card ? SSO_MISSING_ID_COLOR : undefined }}>{row.lastname}</TableCell>
              <TableCell sx={{ color: !row.has_id_card ? SSO_MISSING_ID_COLOR : undefined, fontVariantNumeric: 'tabular-nums' }}>
                {formatCurrency(row.salary)}
              </TableCell>
              <TableCell sx={{ color: !row.has_id_card ? SSO_MISSING_ID_COLOR : undefined, fontVariantNumeric: 'tabular-nums' }}>
                {formatCurrency(row.sso)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
